import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import persistRandomData from "./persistRandomData";

export const store = configureStore({
 reducer: persistRandomData,
});
